import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['searchBarActive'] = false,
  action: Action,
): RootState['searchBarActive'] {
  switch (action.type) {
    case 'SEARCH_BAR_ACTIVE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
